import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function LetsTalkProperty() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="lets-talk-property" className="bg-background relative flex min-h-[40vh] flex-col justify-center overflow-hidden py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,var(--color-muted)_0%,transparent_50%)] opacity-40" />

      <div ref={ref} className={cn("container relative z-10 mx-auto px-4 text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0")}>
        <h1 className="text-foreground font-serif text-4xl font-medium tracking-tight md:text-5xl lg:text-6xl">
          Your Abilene Property Partner.
        </h1>

        <div className="mt-6 flex justify-center">
          <Breadcrumb>
            <BreadcrumbList className="text-muted-foreground sm:gap-2">
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/HomePage" className="hover:text-secondary transition-colors">
                    Home
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="text-foreground font-medium">
                  Reach Out
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </div>
    </section>;
}